import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import {
  InvestmentProviderHttpRepository,
  InvestmentProviderDummyRepository,
} from './infrastructure/repository';

// Application
import { SearchInvestmentProvidersQuery } from './application/queries';

// Domain
import { InvestmentProviderRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupInvestmentProvider(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.INVESTMENT_PROVIDER_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<InvestmentProviderRepository>(TYPES.INVESTMENT_PROVIDER_REPOSITORY)
    .to(
      withDummies
        ? InvestmentProviderDummyRepository
        : InvestmentProviderHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchInvestmentProvidersQuery>(TYPES.SEARCH_INVESTMENT_PROVIDER_QUERY)
    .to(SearchInvestmentProvidersQuery)
    .inSingletonScope();
}
